export function XIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

// Badge-style icons — the circle/square backing is part of the glyph itself
// (drawn in `currentColor`, so hover-to-brand-color still recolors it),
// not a wrapper background, matching the classic two-tone social badge look.
export function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-6 w-6">
      <circle cx="12" cy="12" r="11" fill="currentColor" />
      <path
        d="M13.6 12.5h2.02l.32-2.2h-2.34V8.9c0-.6.2-1.1 1.1-1.1h1.3V5.9c-.22-.02-1-.1-1.9-.1-1.9 0-3.2 1.14-3.2 3.24v1.46H8.7v2.2h2.18V18h2.72z"
        fill="white"
      />
    </svg>
  );
}

export function LinkedInIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-6 w-6">
      <rect x="1" y="1" width="22" height="22" rx="4.5" fill="currentColor" />
      <path
        d="M7.5 9.7h2.5v8h-2.5zM8.75 8.5a1.45 1.45 0 1 1 0-2.9 1.45 1.45 0 0 1 0 2.9zM12.1 9.7h2.4v1.1h.03c.33-.63 1.15-1.3 2.37-1.3 2.53 0 3 1.67 3 3.84v4.36h-2.5v-3.87c0-.92-.02-2.1-1.28-2.1-1.29 0-1.49 1-1.49 2.04v3.93h-2.5z"
        fill="white"
      />
    </svg>
  );
}

export function PinterestIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-6 w-6">
      <circle cx="12" cy="12" r="11" fill="currentColor" />
      <path
        d="M12.2 6.4c-3.1 0-4.9 2.19-4.9 4.34 0 1.05.56 2.36 1.46 2.78.14.06.21 0 .24-.15l.19-.75c.03-.11.02-.16-.06-.26-.28-.34-.5-.94-.5-1.51 0-1.7 1.29-3.34 3.48-3.34 1.89 0 3.22 1.29 3.22 3.13 0 2.08-1.05 3.53-2.42 3.53-.75 0-1.32-.62-1.14-1.39.22-.92.64-1.9.64-2.56 0-.6-.32-1.09-.98-1.09-.78 0-1.4.8-1.4 1.88 0 .68.23 1.14.23 1.14l-.93 3.94c-.28 1.17-.04 2.62-.02 2.76.01.09.13.11.18.04.07-.1 1.04-1.29 1.36-2.42l.52-2c.26.5 1.01.94 1.83.94 2.41 0 4.05-2.2 4.05-5.14 0-2.23-1.9-4.31-4.75-4.31z"
        fill="white"
      />
    </svg>
  );
}

export function LinkIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
      <path d="M10 13a5 5 0 0 0 7.07 0l2.83-2.83a5 5 0 0 0-7.07-7.07L11.5 4.5" />
      <path d="M14 11a5 5 0 0 0-7.07 0L4.1 13.83a5 5 0 0 0 7.07 7.07L12.5 19.5" />
    </svg>
  );
}
